module.exports = __webpack_public_path__ + "img/heart.d047c7f4.svg";